import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/success-icon-line.svg'

export const SuccessIconLine = withSvgProps(SvgComponent)
